import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["signatureContainer", "signatureDots"]

  toggle() {
    if ($("#email-account-field").length) {
      fetch(`/email_accounts/${$("#email-account-field").val()}/signature`, { credentials: "same-origin" })
        .then((response) => response.json())
        .then((response) => {
          if (response.signature !== null && response.signature !== "") {
            $(this.signatureContainerTarget).html(response.signature)
            return
          }

          $(this.signatureDotsTarget).addClass("d-none")
        })
        .catch((error) => {
          $(this.signatureContainerTarget).html("Failed to retrieve your signature")

          console.error(`Failed to retrieve signature: ${error}`)
        })
    }

    $(this.signatureContainerTarget).toggleClass("d-none")
  }
}
